/**
 * Check if array has length, to keep code DRY.
 * @param {Array} input
 */
const checkForLength = (input) => input && input.length !== 0

export { checkForLength }
